import { render, staticRenderFns } from "./AdminDropped2023List.vue?vue&type=template&id=777817b5&scoped=true"
import script from "./AdminDropped2023List.vue?vue&type=script&lang=js"
export * from "./AdminDropped2023List.vue?vue&type=script&lang=js"
import style0 from "./AdminDropped2023List.vue?vue&type=style&index=0&id=777817b5&prod&lang=scss&scoped=true"
import style1 from "./AdminDropped2023List.vue?vue&type=style&index=1&id=777817b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777817b5",
  null
  
)

export default component.exports